module.exports = __webpack_public_path__ + "static/media/deliveryVan_pink.2b0e28df.svg";